import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {},
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    showOTPModal: (state, action) => {
      state.modals.otpModal = action.payload;
    },
    showKeyboardShortcutsModal: (state, action) => {
      state.modals.keyboardShortcutsModal = action.payload;
    },
    showClipEditorSidebarFiltersModal: (state, action) => {
      state.modals.clipEditorSidebarFiltersModal = action.payload;
    },
    showClipEditorContentDeleteModal: (state, action) => {
      state.modals.clipEditorContentDeleteModal = action.payload;
    },
    showClipEditorMediaContentPreviewModal: (state, action) => {
      state.modals.clipEditorMediaContentPreviewModal = action.payload;
    },
    showExportUsageReportModal: (state, action) => {
      state.modals.exportUsageReportModal = action.payload;
    },
    showSendToWorkspaceModal: (state, action) => {
      state.modals.editingSidebarSendToWorkspaceModal = action.payload;
    },
    showUploadBumperModal: (state, action) => {
      state.modals.uploadBumperModal = action.payload;
    },
  },
});

export const {
  showOTPModal,
  showKeyboardShortcutsModal,
  showClipEditorSidebarFiltersModal,
  showClipEditorContentDeleteModal,
  showClipEditorMediaContentPreviewModal,
  showExportUsageReportModal,
  showSendToWorkspaceModal,
  showUploadBumperModal,
} = commonSlice.actions;

export default commonSlice.reducer;
